<template>
  <div id="crew-labors" class="h-full">
    <div class="flex justify-between items-center mx-2 py-2">
      <div class="flex items-center">
        <div class="aisea-text-18-600-dark-gray">労務情報</div>
        <div class="flex items-center ml-6">
          <span class="mr-4 aisea-text-16-400-dark-gray">基準労働期間</span>
          <!-- 基準労働期間ドロップダウン -->
          <standard-working-period
            ref="standardWorkPeriodList"
            :standardWorkPeriodList="labors"
            :selectedStandardWorkPeriod="selectedLabor"
            :changeSelectedStandardWorkPeriod="setSelectedLabor"
          />
        </div>
      </div>
      <div class="flex items-center">
        <vx-tooltip text="編集" position="bottom">
          <feather-icon
            icon="Edit2Icon"
            svg-classes="h-4 w-4 m-4"
            class="crew-list-hover-icon"
            @click.stop="showCrewSidebarForEdit()"
          />
        </vx-tooltip>
        <vs-button
          class="ml-4"
          icon-pack="feather"
          icon="icon-plus"
          :color="AISEA_COLOR.BLUE"
          type="border"
          @click="showCrewSidebarForCreate()"
        >
          新規登録
        </vs-button>
      </div>
    </div>
    <vs-divider class="m-0" />
    <div class="scroll-area">
      <div class="m-6 text-sm">
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >テンプレート</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ templateLabel }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >労働管理責任者</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ laborMgmtRep }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >基準労働期間</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ workPeriodMonth }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >基準労働期間起算日</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ workPeriodFrom }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >基準労働期間末日</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ workPeriodTo }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >時間外労使協定の有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ overtimeLaborAgrmt }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >補償休日労働協定の有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ compensatoryTimeOffLaborAgrmt }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >休息時間分割回数協定の有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ breakLaborAgrmt }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >休日日数の定めの有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ mandatoryDayOff }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >休日日数を定めている場合の日数</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ numOfMandatoryDayOff }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >有給休暇の必要日数</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ numOfMandatoryPaidTimeOff }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >法第72条特例への該当有無</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ marinersLawArt72Applicable }}
          </vs-col>
        </vs-row>
        <vs-divider />
        <vs-row>
          <vs-col vs-w="3" class="pr-4 aisea-text-14-400-black"
            >一日当たりの労働時間上限</vs-col
          >
          <vs-col vs-w="9" class="aisea-text-16-400-black">
            {{ maxWorkHourPerDay }}
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers("crewLabor");
import StandardWorkingPeriod from "../standard-working-period/StandardWorkingPeriod";

export default {
  mixins: [ColorMixin],
  props: {
    enterpriseCrewId: String,
    activeSidebarCrew: Boolean,
    activeTab: Number,
  },
  components: {
    StandardWorkingPeriod
  },
  data () {
    return {
      crewLaborsParam: {},
      DIALOG_ITEM: {
        LABOR_EDIT: 1,
        LABOR_PERIOD_LIST: 2
      },
      dialogItem: null,
      selectedLabor: null,
    }
  },
  computed: {
    ...mapGetters({
      enterpriseCrewLaborId: "enterpriseCrewLaborId",
      crewSelectLabor: "labor"
    }),
    ...mapState({
      crew: state => state.crew,
      labors: state => {
        return state.labors.map(labor => {
          labor.label = `${labor.work_period_from}〜${labor.work_period_to}`
          return labor;
        })
      }
    }),
    sidebarStatus: {
      get () { return this.activeSidebarCrew; },
      set (val) { this.$emit('update:activeSidebarCrew', val) }
    },
    labor () {
      if (!this.labors || !this.selectedLabor) return {};
      return this.labors.find(item => item.id === this.selectedLabor.id);
    },
    templateLabel () {
      if (!this.labor || !this.labor.template) return "未設定"
      return this.labor.template.label ? this.labor.template.label : "未設定"
    },
    laborMgmtRep () {
      if (!this.labor) return "-";
      return this.labor.labor_mgmt_rep ? this.labor.labor_mgmt_rep : "-"
    },
    workPeriodMonth () {
      if (!this.labor) return "-";
      return this.labor.work_period_month ? `${this.labor.work_period_month}ヶ月` : "-"
    },
    workPeriodFrom () {
      if (!this.labor || !this.labor.work_period_from) return "-";
      return this.labor.work_period_from.replace(/-/g, '/');
    },
    workPeriodTo () {
      if (!this.labor || !this.labor.work_period_to) return "-";
      return this.labor.work_period_to.replace(/-/g, '/');
    },
    overtimeLaborAgrmt () {
      if (!this.labor) return "-";
      return "overtime_labor_agrmt" in this.labor ? this.boolToText(this.labor.overtime_labor_agrmt) : "-"
    },
    compensatoryTimeOffLaborAgrmt () {
      if (!this.labor) return "-";
      return "compensatory_time_off_labor_agrmt" in this.labor ? this.boolToText(this.labor.compensatory_time_off_labor_agrmt) : "-"
    },
    breakLaborAgrmt () {
      if (!this.labor) return "-";
      return "break_labor_agrmt" in this.labor ? this.boolToText(this.labor.break_labor_agrmt) : "-"
    },
    mandatoryDayOff () {
      if (!this.labor) return "-";
      return "mandatory_day_off" in this.labor ? this.boolToText(this.labor.mandatory_day_off) : "-"
    },
    numOfMandatoryDayOff () {
      if (!this.labor) return "-";
      return this.labor.num_of_mandatory_day_off ? `${this.labor.num_of_mandatory_day_off}日` : "-"
    },
    numOfMandatoryPaidTimeOff () {
      if (!this.labor) return "-";
      return this.labor.num_of_mandatory_paid_time_off ? `${this.labor.num_of_mandatory_paid_time_off}日` : "-"
    },
    marinersLawArt72Applicable () {
      if (!this.labor) return "-";
      return "mariners_law_art_72_applicable" in this.labor ? this.boolToText(this.labor.mariners_law_art_72_applicable) : "-"
    },
    maxWorkHourPerDay () {
      if (!this.labor || !this.labor.max_work_hour_per_day) return "-"
      return `${this.labor.max_work_hour_per_day}時間`
    },
    isDefault () {
      if (!this.labor.template) return "-"
      if (!("is_default" in this.labor.template)) return "-"
      return this.labor.template.is_default ? "はい" : "いいえ"
    },
  },
  methods: {
    ...mapMutations(["RESET_STATE", "SET_ENTERPRISE_CREW_ID", "SET_ENTERPRISE_CREW_LABOR_ID"]),
    ...mapActions(["fetchCrew", "fetchLaborPeriodList"]),
    showCrewSidebarForCreate () {
      this.SET_ENTERPRISE_CREW_LABOR_ID(null);
      this.crewLaborsParam = {
        latestLabor: this.labors.length > 0 ? this.labors[0] : null
      };
      this.dialogItem = this.DIALOG_ITEM.LABOR_EDIT;
      this.$emit('setDialogTitle', '労務情報追加');
      this.sidebarStatus = true;
    },
    showCrewSidebarForEdit () {
      this.crewLaborsParam = this.labor;
      this.dialogItem = this.DIALOG_ITEM.LABOR_EDIT;
      this.$emit('setDialogTitle', '労務情報編集');
      this.sidebarStatus = true;
    },
    boolToText (bool) {
      return bool ? "有" : "無"
    },
    setSelectedLabor (labor) {
      if (!labor) return;
      this.selectedLabor = this.labors.find(item => item.id === labor.id);
    },
  },
  watch: {
    activeSidebarCrew (val) {
      if (!val) {
        document.getElementById("crew-labors").click();
      }
    },
    async activeTab () {
      this.SET_ENTERPRISE_CREW_ID(this.$route.params.id);
      await this.fetchCrew();
      await this.$refs.standardWorkPeriodList.initWorkingPeriodList();
    },
    async crewSelectLabor (_) {
      await this.$refs.standardWorkPeriodList.initWorkingPeriodList();
      if (!this.selectedLabor) {
        this.selectedLabor = this.labors.find(item => {
          return item.id === this.crewSelectLabor.id
        });
      }
    }

  },
  async mounted () {
    this.SET_ENTERPRISE_CREW_ID(this.$route.params.id);
    await this.fetchCrew();
    await this.$refs.standardWorkPeriodList.initWorkingPeriodList();
  },
  beforeDestroy () {
    this.RESET_STATE();
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#crew-labor {
  .scroll-area {
    overflow-y: auto;
    height: calc(100% + 20px);
  }

  .crew-list-hover-icon {
    border-radius: 4px;
    color: $aisea-gray;
    &:hover {
      background-color: $aisea-light-gray;
    }
  }

  .disabled-icon {
    border-radius: 4px;
    color: $aisea-mouse-gray;
  }

}
</style>
  